import { useTransition } from "react";
import { LOCALES, LOCALE_LABELS, type Locale } from "@/lib/i18n/config";
import { useLocale } from "@/lib/i18n/context";
import { cn } from "@/lib/utils";

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { locale, setLocale } = useLocale();
  const [pending, startTransition] = useTransition();

  function switchTo(next: Locale) {
    if (next === locale || !setLocale) return;
    startTransition(async () => {
      await setLocale(next);
    });
  }

  return (
    <div
      className={cn(
        "inline-flex shrink-0 items-center rounded-lg border border-border bg-card p-0.5 text-xs font-medium",
        className,
      )}
    >
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          disabled={pending}
          onClick={() => switchTo(l)}
          className={cn(
            "rounded-md px-2 py-1 transition-colors disabled:opacity-60 md:px-2.5",
            l === locale
              ? "bg-foreground text-background"
              : "text-muted hover:text-foreground",
          )}
        >
          {/* Short labels on phones so the brand name isn't cramped */}
          <span className="md:hidden">{l === "en" ? "EN" : "ع"}</span>
          <span className="hidden md:inline">{LOCALE_LABELS[l]}</span>
        </button>
      ))}
    </div>
  );
}
